import styled from '@emotion/styled';

import { spacing } from '@/design-system/spacing';

export const StepList = styled('ul')({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[8],
  margin: 0,
  padding: 0,
  listStyle: 'none',
});
